import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import { Link } from 'react-router'
import classNames from 'classnames'
import { makeEndpoint } from 'client/core/api'
import { UsersRequest } from 'client/features/users/actions'
import { ClientsRequest } from 'client/features/client/actions'
import _ from 'underscore'
import { sortUsers } from 'client/features/users/lib'

import URLS from '../../../../constant/URLS'


const User = ({ user, onClick, current }) =>
    <tr className={ classNames({ active: current === user._id }) }>
        <th scope='row'>
            {
                user.disabled && <span><FontAwesome name={ 'ban' }/> </span>
            }
            <Link to={ makeEndpoint(URLS.users.show, user) }>{ user.firstName } { user.lastName }</Link>
        </th>
        <td>
            { !user.disabled && user.admin && <FontAwesome name='check'/> }
        </td>
        <td>
            { !user.disabled && user.limited && <FontAwesome name='check'/> }
        </td>
    </tr>

class Users extends Component {
    constructor() {
        super()
    }

    componentDidMount() {
        this.props.dispatch(UsersRequest.get.action())
        this.props.dispatch(ClientsRequest.get.action())
        if (this.props.user && this.props.user.limited)
            window.location = "/"
    }

    render() {
        return (
            <div>
                <h3 className='page-title'>
                    Utilisateurs
                    <div className='pull-right m-t-25'>
                        <Link className='btn btn-primary waves-effect' to={ URLS.users.new }>
                            <FontAwesome name='plus' />&nbsp;
                            Nouveau
                        </Link>
                    </div>
                </h3>

                <div className='row'>
                    <div className='col-md-4 col-sm-4'>
                        <div className='card-box table-list'>
                            <table className='table table-striped m-0 header-fixed'>
                                <thead>
                                    <tr>
                                        <th>Nom</th>
                                        <th style={ { width: '40px' } }>Logiciel</th>
                                        <th style={ { width: '40px' } }>Limité</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        sortUsers(this.props.users.all).filter(user => !user.disabled).map(user => <User user={ user } key={ user._id } current={ this.props.params.id }/>)
                                    }
                                    {
                                        sortUsers(this.props.users.all).filter(user => user.disabled).map(user => <User user={ user } key={ user._id } current={ this.props.params.id }/>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className='col-md-8'>
                        { this.props.children }
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    const { session, users } = state
    return { user: session.user, users }
}

export default connect(mapStateToProps)(Users)


// WEBPACK FOOTER //
// ./src/client/features/users/containers/Users.jsx